export const ROUTES = {
    LANDING: '/',
    PRIVACY: '/privacy',
    LOGIN: '/login',
    REGISTER: '/register',
    FORGOT_PASSWORD: '/forgot-password',
    HOME: '/transcribe/home',
    TRANSCRIBE: '/transcribe/live',
    HISTORY: '/transcribe/history',
    BIN: '/transcribe/bin',
    PROFILE: '/transcribe/profile',
    CHANGE_PASSWORD: '/transcribe/change-password',
    FEEDBACK: '/transcribe/feedback',
    BIN_MEETING: meetingId => `/transcribe/bin/meeting/${meetingId}`,
    MEETING: meetingId => `/transcribe/meeting/${meetingId}`,
};

/**
 * Browser / redirects sometimes leave a trailing slash. Layout and route checks
 * must treat /transcribe/home/ like /transcribe/home or the outlet can stay visible
 * on top of the home shell after POP.
 */
export const normalizeAppPathname = pathname => {
    if (!pathname || pathname.length <= 1) {
        return pathname || '/';
    }
    return pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
};

export const isTranscriptRoute = pathname => {
    const p = normalizeAppPathname(pathname);
    return (
        p === ROUTES.HOME ||
        p === ROUTES.TRANSCRIBE ||
        p.startsWith('/transcribe/meeting/') ||
        p.startsWith('/transcribe/bin/meeting/')
    );
};
